// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-portal__au-modal-button-push {
  margin-right: auto !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/acma-spa/dist/layout/Modal.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;AACF","sourcesContent":[".au-modal-button-push {\r\n  margin-right: auto !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"au-modal-button-push": `client-portal__au-modal-button-push`
};
export default ___CSS_LOADER_EXPORT___;
